import React from 'react';
import { ConfirmPointsDialog } from './LifecycleDialogs';

const plural = (count, one, many) => `${count} ${count === 1 ? one : many}`;

/**
 * End event: the counts come from `GET /end-preview`, which uses the same selector `POST /end` does, so the
 * number here is what End moves (1013-33). While the preview loads, or when it failed, End stays disabled.
 */
export default function EndEventDialog({ open, onClose, onConfirm, preview, loading, error, busy, eventLine, endClock }) {
    const ready = Boolean(preview) && !loading;
    const going = Number(preview?.going_without_check_in || 0);
    const attended = Number(preview?.attended || 0);
    const unconfirmed = Number(preview?.unconfirmed || 0);
    const points = ready ? [
        { icon: 'userx', text: `${plural(going, 'Going guest hasn’t', 'Going guests haven’t')} checked in. They move to No-show.` },
        { icon: 'badge', text: `${plural(attended, 'checked-in guest stays', 'checked-in guests stay')} in Attended with a thank-you due.` },
        { icon: 'mail', text: `${plural(unconfirmed, 'guest who never confirmed stays', 'guests who never confirmed stay')} where they are, so you can reschedule or close them.` },
        { icon: 'undo', text: 'Someone arrives late? Reopen check-in, or switch them on in Check-in.' },
        { icon: 'clock', text: `If nobody ends it, it ends on its own${endClock ? ` at ${endClock}` : ''} on the day.` },
    ] : [{ icon: 'info', text: loading ? 'Counting who would move…' : (error || 'The counts could not be loaded.') }];
    return (
        <ConfirmPointsDialog
            open={open} onClose={onClose} onConfirm={onConfirm} busy={busy} disabled={!ready} danger testId="end-event-dialog"
            title="End the event?" sub={eventLine ? `Closes check-in · ${eventLine}` : 'Closes check-in'} primary="End event" points={points}
        />
    );
}
